export enum TextBoxSize {
  Small = 'small',
  Default = 'default',
  Large = 'large'
}
